<template>
    <Card>
        <p slot="title">
            发票信息：
            {{info.invoiceType=='NOT'||!info.invoiceType?'不开发票':(info.invoiceType=='VAT'?'专票（纸质）':'普票（电子）')}} 
        </p>
        <Form :label-width="150" class="mt15" v-if="info.invoiceType&&info.invoiceType!='NOT'">
            <FormItem label="公司名称：" class="w600">
                {{info.invoiceName}}
            </FormItem>
            <FormItem label="统一社会信用代码：" class="w600">
                {{info.invoiceUniqueCode}}
            </FormItem>
            <FormItem label="开户地址：" class="w600">
                {{info.invoiceAddress}}
            </FormItem>
            <FormItem label="联系电话：" class="w600">
                {{info.invoicePhone}}
            </FormItem>
            <FormItem label="开户行：" class="w600">
                {{info.openingBankName}}
            </FormItem>
            <FormItem label="对公账号：" class="w600">
                {{info.openingBankAccount}}
            </FormItem>
            <FormItem label="电子邮箱：" class="w600">
                {{info.invoiceDeliverEmail}}
            </FormItem>
            <FormItem label="邮寄地址：" class="w600">
                {{info.invoiceDeliverAddress}}
            </FormItem>
        </Form>
    </Card>
    </template>
    <script>
    export default {
        props:{
            info:Object,
        },
    }
    </script>
    <style scoped>
        span.red{
            font-size: 14px;
            margin-left: 15px;
            color:red;
        }
    </style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedDadi/common/invoiceInfo.vue